export class PathInvModel {
pathinvcode = '' ;
pdate = '2022-01-01' ;
pathinvpathology = '' ;
pathinvtype = '' ;
pathinvsite = '' ;
pathinvhtype = '' ;
pathinvothers = '' ;
pagrade = '' ;
pat = '' ;
pan = '' ;
pathinvcomment = '' ;
pathihc = '' ;
pathimg ;
pdate1 = '2022-01-01';
compcode = '1' ;
userid = 'sa' ;
modifieddate = '2022-01-01' ;
}
